module.exports = __webpack_public_path__ + "img/NoExpressionFace.da9ae8bb.svg";